import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiOffSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.3 2.124a.5.5 0 0 0-.707.012L2.915 12.143a.5.5 0 1 0 .72.694l8.59-8.88 1.088-1.126a.5.5 0 0 0-.013-.707ZM8 3c.722 0 1.44.08 2.14.237L8.409 5.03a7.835 7.835 0 0 0-5.994 2.327L1 5.928A9.888 9.888 0 0 1 4.212 3.76 9.813 9.813 0 0 1 8 3.001ZM10.236 7.456 8.64 9.11a4.218 4.218 0 0 1 2.185 1.037l1.416-1.43a6.244 6.244 0 0 0-2.005-1.26ZM6.215 7.302 4.311 9.273l-.552-.557a6.229 6.229 0 0 1 2.456-1.414ZM13.137 4.452l-1.442 1.493a7.93 7.93 0 0 1 1.89 1.412L15 5.93a9.916 9.916 0 0 0-1.863-1.477ZM9.379 11.607a2.064 2.064 0 0 0-2.757 0L8 13l1.379-1.393Z" />
  </svg>
);
export default IconWifiOffSizeS;
